import React from 'react';
import styled from 'styled-components';
import logo from "../assets/logo.jpeg";
import BrandIcon from './Brand';

const FooterWrapper = styled.footer`
  background-color: #000;
  color: #fff;
  padding: 50px 20px;
  text-align: center;

  .footer-logo {
    display: flex;
    justify-content: center;
    align-items: center; 
    gap: 10px; 
    margin-bottom: 30px;

    img {
      max-width: 60px;
    }
  }

  .footer-disclaimer {
    margin: 30px auto;
    font-size: 14px; 
    line-height: 1.7;
    color: #ddd;
    max-width: 800px;
  }

  .footer-bottom {
    border-top: 1px solid #444;
    margin-top: 20px;
    font-size: 16px;

    p {
      margin: 0;
    }
  }

  @media (max-width: 768px) {
    padding: 30px 15px;

    .footer-logo img {
      max-width: 120px;
    }

    .footer-disclaimer {
      font-size: 14px;
    }
  }

  @media (max-width: 480px) {
    padding: 20px 10px;
    width: 100%;

    .footer-logo {
      gap: 5px; 
    }

    .footer-logo img {
      max-width: 60px;
    }

    .footer-disclaimer {
      font-size: 12px;
    }

    .footer-bottom {
      font-size: 12px;
    }
  }
`;

const Footer = () => {
  return (
    <FooterWrapper id='footer'>
      <div className="footer-logo">
        <img src={logo} alt="Company Logo" />
        <BrandIcon />
      </div>
      <div className="footer-disclaimer">
        <p style={{fontSize:"10px"}}>
          <strong>Marketed By Authorised Channel Partner</strong>, RERA Registration
          No- PRM/KA/RERA/1251/446/AG/201012/002062. The information provided on this website is intended exclusively for
          informational purposes and should not be construed as an offer of services. This site is managed by a RERA-authorized real estate agent namely Indo Property Service LLP. The pricing information presented on this website is subject to alteration without advance notification, and the assurance of property availability cannot be guaranteed. Images showcased on this website are for representational purposes only and may not accurately reflect the actual properties. We may share your data with Real Estate Regulatory Authority (RERA) registered Developers for further processing. Additionally, updates and information may be sent to the mobile number or email address registered with us. All rights reserved. The content, design, and information on this website are protected by copyright and other intellectual property rights. Any unauthorized use or reproduction may violate applicable laws. Contact us directly for accurate details about services, pricing, or availability.
        </p>
      </div>
      <div className="footer-bottom">
        <p style={{marginTop:"10px"}}>&copy; All Rights Reserved Rankmantra, 2024</p>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
